import { styled } from "styled-components";

import SectionTitle from "../atoms/SectionTitle";
import Section, { StyledSectionImage } from "../molecules/Section";

import WhatIDoImage from "../../assets/icons/whatido.svg";

const WhatIDo = () => {
  return (
    <Section id="whatido">
      <SectionTitle title="what i do" />
      <StyledSectionImage src={WhatIDoImage} alt="" />
      <StyledUL>
        <li>
          <span>projects in figma</span>
        </li>
        <li>
          <span>websites</span>
        </li>
        <li>
          <span>web apps</span>
        </li>
        {/* <li>
          <span>simple ml models</span>
        </li> */}
      </StyledUL>
    </Section>
  );
};

const StyledUL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  text-transform: uppercase;
  margin-top: 48px;
  font-weight: 900;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primaryText07};

  li {
    border-top: 1px solid ${({ theme }) => theme.colors.primaryText02};
    position: relative;
    overflow: hidden;
    transition: color 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
    span {
      position: relative;
      z-index: 3;
    }
    &::after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.highlightedText};
      left: 0;
      top: 0;
      transform: scaleX(0);
      transform-origin: 0 50%;
      transition: transform 0.4s cubic-bezier(0.61, 0.07, 0.23, 0.89);
      z-index: 1;
    }
    &:hover {
      color: ${({ theme }) => theme.colors.bg};
      &::after {
        transform: scaleX(1);
      }
    }
  }
  li:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.primaryText02};
  }

  @media (min-width: 335px) {
    font-size: 28px;
  }
  @media (min-width: 500px) {
    font-size: 32px;
  }
  @media (min-width: 750px) {
    font-size: 38px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
  }
`;

export default WhatIDo;
